(function(){"use strict";try{if(typeof document!="undefined"){var e=document.createElement("style");e.appendChild(document.createTextNode("")),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { jsx as e, jsxs as r, Fragment as f } from "react/jsx-runtime";
import $ from "clsx";
import ne, { useContext as C, useRef as O, useState as R, useCallback as de, useEffect as ue } from "react";
import { MDBDropdown as N, MDBDropdownToggle as B, MDBDropdownMenu as D, MDBDropdownItem as a, MDBBtnGroup as v, MDBTooltip as s, MDBIcon as l, MDBInput as J } from "mdb-react-ui-kit";
const w = ne.createContext({
  performAction: () => {
  },
  colors: [],
  active: !1,
  setActive: null,
  imageInput: "",
  linkInput: { url: "", description: "" },
  setImageInput: null,
  setLinkInput: null,
  translations: {
    paragraph: "Paragraph",
    textStyle: "Text style",
    heading: "Heading",
    preformatted: "Preformatted",
    bold: "Bold",
    italic: "Italic",
    strikethrough: "Strikethrough",
    underline: "Underline",
    textcolor: "Color",
    textBackgroundColor: "Background Color",
    alignLeft: "Align Left",
    alignCenter: "Align Center",
    alignRight: "Align Right",
    alignJustify: "Align Justify",
    insertLink: "Insert Link",
    insertPicture: "Insert Picture",
    unorderedList: "Unordered List",
    orderedList: "Numbered List",
    increaseIndent: "Increase Indent",
    decreaseIndent: "Decrease Indent",
    insertHorizontalRule: "Insert Horizontal Line",
    showHTML: "Show HTML code",
    undo: "Undo",
    redo: "Redo",
    addLinkHead: "Add Link",
    addImageHead: "Add Image",
    linkUrlLabel: "Enter a URL:",
    linkDescription: "Enter a description",
    imageUrlLabel: "Enter a URL:",
    okButton: "OK",
    cancelButton: "cancel",
    moreOptions: "Show More Options"
  }
}), pe = () => {
  const { performAction: o, translations: t } = C(w);
  return /* @__PURE__ */ e("div", { className: "wysiwyg-toolbar-group", children: /* @__PURE__ */ r(N, { className: "mx-1", children: [
    /* @__PURE__ */ e(B, { className: "btn-sm btn-light wysiwyg-btn shadow-0 mt-1", type: "button", children: t == null ? void 0 : t.textStyle }),
    /* @__PURE__ */ r(D, { className: "wysiwyg-toolbar-options-list", style: { minWidth: "8rem" }, children: [
      /* @__PURE__ */ e(a, { link: !0, onClick: () => o("formatBlock", "p"), href: "#!", children: t == null ? void 0 : t.paragraph }),
      /* @__PURE__ */ r(a, { link: !0, onClick: () => o("formatBlock", "h1"), href: "#!", children: [
        t == null ? void 0 : t.heading,
        " 1"
      ] }),
      /* @__PURE__ */ r(a, { link: !0, onClick: () => o("formatBlock", "h2"), href: "#!", children: [
        t == null ? void 0 : t.heading,
        " 2"
      ] }),
      /* @__PURE__ */ r(a, { link: !0, onClick: () => o("formatBlock", "h3"), href: "#!", children: [
        t == null ? void 0 : t.heading,
        " 3"
      ] }),
      /* @__PURE__ */ r(a, { link: !0, onClick: () => o("formatBlock", "h4"), href: "#!", children: [
        t == null ? void 0 : t.heading,
        " 4"
      ] }),
      /* @__PURE__ */ r(a, { link: !0, onClick: () => o("formatBlock", "h5"), href: "#!", children: [
        t == null ? void 0 : t.heading,
        " 5"
      ] }),
      /* @__PURE__ */ r(a, { link: !0, onClick: () => o("formatBlock", "h6"), href: "#!", children: [
        t == null ? void 0 : t.heading,
        " 6"
      ] }),
      /* @__PURE__ */ e(a, { link: !0, onClick: () => o("formatBlock", "pre"), href: "#!", children: t == null ? void 0 : t.preformatted })
    ] })
  ] }) });
}, te = () => {
  const o = {
    minWidth: "32px",
    minHeight: "32px",
    paddingLeft: "0.5rem",
    paddingRight: "0.5rem"
  }, t = {
    maxWidth: "8rem",
    minWidth: "8rem"
  }, { performAction: c, colors: u, translations: i } = C(w);
  return /* @__PURE__ */ e("div", { className: "wysiwyg-toolbar-group", children: /* @__PURE__ */ r(v, { shadow: "0", size: "sm", className: "mx-1 shadow-0", role: "group", children: [
    /* @__PURE__ */ e(
      s,
      {
        disableMouseDown: !0,
        placement: "bottom",
        tag: "button",
        wrapperClass: "btn btn-light wysiwyg-btn",
        wrapperProps: {
          onClick: () => c("bold", void 0),
          type: "button"
        },
        title: i == null ? void 0 : i.bold,
        children: /* @__PURE__ */ e(l, { fas: !0, icon: "bold" })
      }
    ),
    /* @__PURE__ */ e(
      s,
      {
        disableMouseDown: !0,
        placement: "bottom",
        tag: "button",
        wrapperClass: "btn btn-light wysiwyg-btn",
        wrapperProps: {
          onClick: () => c("italic", void 0),
          type: "button"
        },
        title: i == null ? void 0 : i.italic,
        children: /* @__PURE__ */ e(l, { fas: !0, icon: "italic" })
      }
    ),
    /* @__PURE__ */ e(
      s,
      {
        disableMouseDown: !0,
        placement: "bottom",
        tag: "button",
        wrapperClass: "btn btn-light wysiwyg-btn",
        wrapperProps: {
          onClick: () => c("underline"),
          type: "button"
        },
        title: i == null ? void 0 : i.underline,
        children: /* @__PURE__ */ e(l, { fas: !0, icon: "underline" })
      }
    ),
    /* @__PURE__ */ e(
      s,
      {
        disableMouseDown: !0,
        placement: "bottom",
        tag: "button",
        wrapperClass: "btn btn-light wysiwyg-btn",
        wrapperProps: {
          onClick: () => c("strikethrough"),
          type: "button"
        },
        title: i == null ? void 0 : i.strikethrough,
        children: /* @__PURE__ */ e(l, { fas: !0, icon: "strikethrough" })
      }
    ),
    /* @__PURE__ */ r(N, { children: [
      /* @__PURE__ */ e(B, { className: "btn-light wysiwyg-btn shadow-0", style: o, type: "button", children: /* @__PURE__ */ e(l, { fas: !0, icon: "font" }) }),
      /* @__PURE__ */ e(D, { style: t, children: u.map((n, d) => /* @__PURE__ */ e(
        a,
        {
          tag: "button",
          type: "button",
          className: "wysiwyg-color btn btn-link",
          style: { background: n, display: "inline-block" },
          onClick: () => c("foreColor", n),
          href: "#!"
        },
        d
      )) })
    ] }),
    /* @__PURE__ */ r(N, { children: [
      /* @__PURE__ */ e(B, { className: "btn-light wysiwyg-btn shadow-0", style: o, type: "button", children: /* @__PURE__ */ e(l, { fas: !0, icon: "paint-brush" }) }),
      /* @__PURE__ */ e(D, { style: t, children: u.map((n, d) => /* @__PURE__ */ e(
        a,
        {
          tag: "button",
          type: "button",
          className: "wysiwyg-color btn btn-link",
          style: { background: n, display: "inline-block" },
          onClick: () => c("backColor", n),
          href: "#!"
        },
        d
      )) })
    ] })
  ] }) });
}, _ = () => {
  const { performAction: o, translations: t } = C(w);
  return /* @__PURE__ */ e("div", { className: "wysiwyg-toolbar-group", children: /* @__PURE__ */ r(v, { size: "sm", shadow: "0", className: "mx-1", role: "group", children: [
    /* @__PURE__ */ e(
      s,
      {
        disableMouseDown: !0,
        placement: "bottom",
        tag: "button",
        wrapperClass: "btn btn-light wysiwyg-btn",
        wrapperProps: {
          onClick: () => o("justifyleft"),
          type: "button"
        },
        title: t == null ? void 0 : t.alignLeft,
        children: /* @__PURE__ */ e(l, { fas: !0, icon: "align-left" })
      }
    ),
    /* @__PURE__ */ e(
      s,
      {
        disableMouseDown: !0,
        placement: "bottom",
        tag: "button",
        wrapperClass: "btn btn-light wysiwyg-btn",
        wrapperProps: {
          onClick: () => o("justifycenter"),
          type: "button"
        },
        title: t == null ? void 0 : t.alignCenter,
        children: /* @__PURE__ */ e(l, { fas: !0, icon: "align-center" })
      }
    ),
    /* @__PURE__ */ e(
      s,
      {
        disableMouseDown: !0,
        placement: "bottom",
        tag: "button",
        wrapperClass: "btn btn-light wysiwyg-btn",
        wrapperProps: {
          onClick: () => o("justifyright"),
          type: "button"
        },
        title: t == null ? void 0 : t.alignRight,
        children: /* @__PURE__ */ e(l, { fas: !0, icon: "align-right" })
      }
    ),
    /* @__PURE__ */ e(
      s,
      {
        disableMouseDown: !0,
        placement: "bottom",
        tag: "button",
        wrapperClass: "btn btn-light wysiwyg-btn",
        wrapperProps: {
          onClick: () => o("justifyfull"),
          type: "button"
        },
        title: t == null ? void 0 : t.alignJustify,
        children: /* @__PURE__ */ e(l, { fas: !0, icon: "align-justify" })
      }
    )
  ] }) });
}, z = () => {
  const { performAction: o, translations: t } = C(w);
  return /* @__PURE__ */ e("div", { className: "wysiwyg-toolbar-group", children: /* @__PURE__ */ r(v, { size: "sm", shadow: "0", className: "mx-1", role: "group", children: [
    /* @__PURE__ */ e(
      s,
      {
        disableMouseDown: !0,
        placement: "bottom",
        tag: "button",
        wrapperClass: "btn btn-light wysiwyg-btn",
        wrapperProps: {
          onClick: () => o("insertUnorderedList"),
          type: "button"
        },
        title: t == null ? void 0 : t.unorderedList,
        children: /* @__PURE__ */ e(l, { fas: !0, icon: "list-ul" })
      }
    ),
    /* @__PURE__ */ e(
      s,
      {
        disableMouseDown: !0,
        placement: "bottom",
        tag: "button",
        wrapperClass: "btn btn-light wysiwyg-btn",
        wrapperProps: {
          onClick: () => o("insertOrderedList"),
          type: "button"
        },
        title: t == null ? void 0 : t.orderedList,
        children: /* @__PURE__ */ e(l, { fas: !0, icon: "list-ol" })
      }
    ),
    /* @__PURE__ */ e(
      s,
      {
        disableMouseDown: !0,
        placement: "bottom",
        tag: "button",
        wrapperClass: "btn btn-light wysiwyg-btn",
        wrapperProps: {
          onClick: () => o("outdent"),
          type: "button"
        },
        title: t == null ? void 0 : t.decreaseIndent,
        children: /* @__PURE__ */ e(l, { fas: !0, icon: "outdent" })
      }
    ),
    /* @__PURE__ */ e(
      s,
      {
        disableMouseDown: !0,
        placement: "bottom",
        tag: "button",
        wrapperClass: "btn btn-light wysiwyg-btn",
        wrapperProps: {
          onClick: () => o("indent"),
          type: "button"
        },
        title: t == null ? void 0 : t.increaseIndent,
        children: /* @__PURE__ */ e(l, { fas: !0, icon: "indent" })
      }
    )
  ] }) });
}, A = () => {
  const { imageInput: o, setImageInput: t, linkInput: c, setLinkInput: u, performAction: i, translations: n } = C(w), d = {
    minWidth: "32px",
    minHeight: "32px",
    paddingLeft: "0.5rem",
    paddingRight: "0.5rem"
  }, g = {
    color: "#fff",
    borderRadius: "0.25rem",
    padding: "0.625rem 1.5rem 0.5rem 1.5rem",
    textAlign: "center",
    width: "auto"
  }, P = (m) => {
    console.log(c), u({ ...c, [m.target.name]: m.target.value });
  }, h = (m) => {
    t(m.target.value);
  };
  return /* @__PURE__ */ e("div", { className: "wysiwyg-toolbar-group", children: /* @__PURE__ */ r(v, { id: "links-section", size: "sm", shadow: "0", className: "mx-1", role: "group", children: [
    /* @__PURE__ */ r(N, { children: [
      /* @__PURE__ */ e(B, { className: "btn-light wysiwyg-btn shadow-0", style: d, type: "button", children: /* @__PURE__ */ e(l, { fas: !0, icon: "paperclip" }) }),
      /* @__PURE__ */ e(D, { className: "dropdown-menu-sm-end", style: { minWidth: "25vw" }, children: /* @__PURE__ */ r("form", { className: "px-4 py-3", children: [
        /* @__PURE__ */ e("h5", { className: "mb-3", children: n == null ? void 0 : n.addLinkHead }),
        /* @__PURE__ */ e(
          J,
          {
            name: "url",
            value: c.url,
            onChange: P,
            label: n == null ? void 0 : n.linkUrlLabel,
            className: "mb-4"
          }
        ),
        /* @__PURE__ */ e(
          J,
          {
            name: "description",
            value: c.description,
            onChange: P,
            label: n == null ? void 0 : n.linkDescription,
            className: "mb-4"
          }
        ),
        /* @__PURE__ */ r("div", { className: "d-flex justify-content-end", children: [
          /* @__PURE__ */ e(
            a,
            {
              divider: !0,
              childTag: "span",
              tag: "button",
              type: "button",
              className: "btn btn-primary disable-border",
              style: g,
              children: n == null ? void 0 : n.okButton
            }
          ),
          /* @__PURE__ */ e(
            a,
            {
              divider: !0,
              childTag: "span",
              tag: "button",
              type: "button",
              className: "btn btn-primary disable-border",
              style: g,
              children: n == null ? void 0 : n.cancelButton
            }
          )
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ r(N, { children: [
      /* @__PURE__ */ e(B, { className: "btn-light wysiwyg-btn shadow-0", style: d, type: "button", children: /* @__PURE__ */ e(l, { far: !0, icon: "image" }) }),
      /* @__PURE__ */ e(D, { className: "dropdown-menu-sm-end", style: { minWidth: "25vw" }, children: /* @__PURE__ */ r("form", { className: "px-4 py-3", children: [
        /* @__PURE__ */ e("h5", { className: "mb-3", children: n == null ? void 0 : n.addImageHead }),
        /* @__PURE__ */ e(
          J,
          {
            value: o,
            onChange: h,
            label: n == null ? void 0 : n.imageUrlLabel,
            className: "mb-4"
          }
        ),
        /* @__PURE__ */ r("div", { className: "d-flex justify-content-end", children: [
          /* @__PURE__ */ e(
            a,
            {
              divider: !0,
              childTag: "span",
              onClick: () => i("insertpicture"),
              style: g,
              tag: "button",
              type: "button",
              className: "btn btn-primary disable-border",
              children: n == null ? void 0 : n.okButton
            }
          ),
          /* @__PURE__ */ e(
            a,
            {
              divider: !0,
              childTag: "span",
              style: g,
              tag: "button",
              type: "button",
              className: "btn btn-primary ms-2 disable-border",
              children: n == null ? void 0 : n.cancelButton
            }
          )
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ e(
      s,
      {
        disableMouseDown: !0,
        placement: "bottom",
        tag: "button",
        wrapperClass: "btn btn-light wysiwyg-btn",
        wrapperProps: {
          onClick: (m) => {
            m.preventDefault(), i("insertHorizontalRule");
          }
        },
        title: n == null ? void 0 : n.insertHorizontalRule,
        children: /* @__PURE__ */ e(l, { fas: !0, icon: "grip-lines" })
      }
    )
  ] }) });
}, k = () => {
  const { performAction: o, translations: t } = C(w);
  return /* @__PURE__ */ e("div", { className: "wysiwyg-toolbar-group", children: /* @__PURE__ */ r(v, { size: "sm", shadow: "0", className: "mx-1", role: "group", children: [
    /* @__PURE__ */ e(
      s,
      {
        disableMouseDown: !0,
        placement: "bottom",
        tag: "button",
        wrapperClass: "btn btn-light wysiwyg-btn",
        wrapperProps: {
          onClick: () => o("undo"),
          type: "button"
        },
        title: t == null ? void 0 : t.undo,
        children: /* @__PURE__ */ e(l, { fas: !0, icon: "angle-left" })
      }
    ),
    /* @__PURE__ */ e(
      s,
      {
        disableMouseDown: !0,
        placement: "bottom",
        tag: "button",
        wrapperClass: "btn btn-light wysiwyg-btn",
        wrapperProps: {
          onClick: () => o("redo"),
          type: "button"
        },
        title: t == null ? void 0 : t.redo,
        children: /* @__PURE__ */ e(l, { fas: !0, icon: "angle-right" })
      }
    )
  ] }) });
}, M = () => {
  const { performAction: o, active: t, setActive: c, translations: u } = C(w), i = $(t && "active", "btn btn-light wysiwyg-btn");
  return /* @__PURE__ */ e("div", { className: "ms-auto wysiwyg-toolbar-group", children: /* @__PURE__ */ e(v, { size: "sm", shadow: "0", className: "mx-1", role: "group", children: /* @__PURE__ */ e(
    s,
    {
      disableMouseDown: !0,
      placement: "bottom",
      tag: "button",
      wrapperClass: i,
      wrapperProps: {
        onClick: () => {
          o("toggleHTML"), c(!t);
        },
        type: "button"
      },
      title: u == null ? void 0 : u.showHTML,
      children: /* @__PURE__ */ e(l, { fas: !0, icon: "code" })
    }
  ) }) });
}, ye = ne.forwardRef(
  ({
    className: o,
    children: t,
    colors: c = [
      "#1266F1",
      // Primary
      "#B23CFD",
      // Secondary
      "#00B74A",
      // Success
      "#F93154",
      // Danger
      "#FFA900",
      // Warning
      "#39C0ED",
      // Info
      "#FBFBFB",
      // Light
      "#262626"
      // Dark
    ],
    disableFormatting: u,
    disableCode: i,
    disableJustify: n,
    disableLinks: d,
    disableLists: g,
    disableStyles: P,
    disableUndoRedo: h,
    fixedTop: m,
    offsetTop: re = "0px",
    translations: oe = {
      paragraph: "Paragraph",
      textStyle: "Text style",
      heading: "Heading",
      preformatted: "Preformatted",
      bold: "Bold",
      italic: "Italic",
      strikethrough: "Strikethrough",
      underline: "Underline",
      textcolor: "Color",
      textBackgroundColor: "Background Color",
      alignLeft: "Align Left",
      alignCenter: "Align Center",
      alignRight: "Align Right",
      alignJustify: "Align Justify",
      insertLink: "Insert Link",
      insertPicture: "Insert Picture",
      unorderedList: "Unordered List",
      orderedList: "Numbered List",
      increaseIndent: "Increase Indent",
      decreaseIndent: "Decrease Indent",
      insertHorizontalRule: "Insert Horizontal Line",
      showHTML: "Show HTML code",
      undo: "Undo",
      redo: "Redo",
      addLinkHead: "Add Link",
      addImageHead: "Add Image",
      linkUrlLabel: "Enter a URL:",
      linkDescription: "Enter a description",
      imageUrlLabel: "Enter a URL:",
      okButton: "OK",
      cancelButton: "cancel",
      moreOptions: "Show More Options"
    },
    onChange: q,
    ...ie
  }, le) => {
    const L = O(null), E = O(null), K = O([]), [U, j] = R(!1), [y, G] = R(0), [Q, V] = R({
      url: "",
      description: ""
    }), [X, Y] = R(""), W = de(() => {
      const p = E.current, T = L.current;
      if (!p || !T)
        return;
      const b = T.offsetWidth, x = p.querySelectorAll(".wysiwyg-toolbar-group:not(.wysiwyg-toolbar-toggler)");
      let I = 0;
      const S = p.querySelector(".wysiwyg-toolbar-toggler .dropdown-toggle");
      S && (I += S.offsetWidth), x.forEach((H, Z) => {
        const ee = H.classList.contains("wysiwyg-hide");
        I += H.offsetWidth || K.current[Z], b < I && !ee ? (K.current[Z] = H.offsetWidth, H.classList.add("wysiwyg-hide"), G((F) => F + 1)) : b > I && ee && (G((F) => F - 1), H.classList.remove("wysiwyg-hide"));
      });
    }, [E, L]), se = (p, T) => {
      const b = L.current;
      if (b) {
        if (b.focus(), p === "insertlink" || p === "insertpicture") {
          let x;
          if (p === "insertlink") {
            const { url: I, description: S } = Q;
            x = `<a href="${I}" target="_blank">${S}</a>`, V({ description: "", url: "" });
          } else
            x = `<img src="${X}" target="_blank" class="img-fluid" />`, Y("");
          document.execCommand("insertHTML", !1, x);
        }
        if (p === "toggleHTML") {
          U ? (b.innerHTML = b.textContent, j(!1)) : (b.textContent = b.innerHTML, j(!0));
          return;
        }
        document.execCommand(p, !1, T);
      }
    };
    ue(() => (W(), window.addEventListener("resize", W), () => {
      window.removeEventListener("resize", W);
    }), [W]);
    const ce = $("wysiwyg", U && "wysiwyg-show-html", o), ae = $("wysiwyg-toolbar btn-toolbar", m && "sticky-top");
    return /* @__PURE__ */ r(f, { children: [
      /* @__PURE__ */ e("textarea", { className: "wysiwyg-textarea" }),
      /* @__PURE__ */ r("div", { ref: le, className: ce, ...ie, onInput: (p) => {
        L.current && q && q(L.current.innerHTML);
      }, children: [
        /* @__PURE__ */ e(
          w.Provider,
          {
            value: {
              performAction: se,
              active: U,
              setActive: j,
              colors: c,
              imageInput: X,
              setImageInput: Y,
              linkInput: Q,
              setLinkInput: V,
              translations: oe
            },
            children: /* @__PURE__ */ r("div", { ref: E, className: ae, style: { top: re }, role: "toolbar", children: [
              !P && /* @__PURE__ */ e(pe, {}),
              !u && /* @__PURE__ */ e(te, {}),
              !n && /* @__PURE__ */ e(_, {}),
              !g && /* @__PURE__ */ e(z, {}),
              !d && /* @__PURE__ */ e(A, {}),
              !i && /* @__PURE__ */ e(M, {}),
              !h && /* @__PURE__ */ e(k, {}),
              y > 0 && /* @__PURE__ */ e("div", { className: "ms-auto wysiwyg-toolbar-group wysiwyg-toolbar-toggler", children: /* @__PURE__ */ r(N, { children: [
                /* @__PURE__ */ e(B, { className: "btn-sm btn-light wysiwyg-btn shadow-0", children: /* @__PURE__ */ e(l, { fas: !0, icon: "ellipsis-h" }) }),
                /* @__PURE__ */ e(D, { children: /* @__PURE__ */ r(f, { children: [
                  y === 1 && !h && /* @__PURE__ */ e(k, {}),
                  y === 2 && /* @__PURE__ */ r(f, { children: [
                    !i && /* @__PURE__ */ e(M, {}),
                    !h && /* @__PURE__ */ e(k, {})
                  ] }),
                  y === 3 && /* @__PURE__ */ r(f, { children: [
                    !d && /* @__PURE__ */ e(A, {}),
                    !i && /* @__PURE__ */ e(M, {}),
                    !h && /* @__PURE__ */ e(k, {})
                  ] }),
                  y === 4 && /* @__PURE__ */ r(f, { children: [
                    !g && /* @__PURE__ */ e(z, {}),
                    !d && /* @__PURE__ */ e(A, {}),
                    !i && /* @__PURE__ */ e(M, {}),
                    !h && /* @__PURE__ */ e(k, {})
                  ] }),
                  y === 5 && /* @__PURE__ */ r(f, { children: [
                    !n && /* @__PURE__ */ e(_, {}),
                    !g && /* @__PURE__ */ e(z, {}),
                    !d && /* @__PURE__ */ e(A, {}),
                    !i && /* @__PURE__ */ e(M, {}),
                    !h && /* @__PURE__ */ e(k, {})
                  ] }),
                  y === 6 && /* @__PURE__ */ r(f, { children: [
                    !u && /* @__PURE__ */ e(te, {}),
                    !n && /* @__PURE__ */ e(_, {}),
                    !g && /* @__PURE__ */ e(z, {}),
                    !d && /* @__PURE__ */ e(A, {}),
                    !i && /* @__PURE__ */ e(M, {}),
                    !h && /* @__PURE__ */ e(k, {})
                  ] })
                ] }) })
              ] }) })
            ] })
          }
        ),
        /* @__PURE__ */ e(
          "div",
          {
            ref: L,
            className: "wysiwyg-content",
            suppressContentEditableWarning: !0,
            contentEditable: !0,
            spellCheck: !1,
            children: t
          }
        )
      ] })
    ] });
  }
);
export {
  ye as MDBWysiwyg
};
